// extracted by mini-css-extract-plugin
export default {"wrapper":"ModerationIcon_wrapper__6sCiQ","text":"ModerationIcon_text__JgP6P"};